export default __webpack_public_path__ + "static/pab-presentation-f0a99e8d6f710ada60336c5ec3dd5003.png";